"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseOutlined = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.CloseOutlined = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M14.5859 16.0001L7.29297 8.70718L8.70718 7.29297L16.0001 14.5859L23.293 7.29297L24.7072 8.70718L17.4143 16.0001L24.7072 23.293L23.293 24.7072L16.0001 17.4143L8.70718 24.7072L7.29297 23.293L14.5859 16.0001Z", fillRule: "evenodd" })),
        size === 'medium' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "M10.9384 11.9991L4.96875 6.02941L6.02941 4.96875L11.9991 10.9384L17.9687 4.96875L19.0294 6.02941L13.0597 11.9991L19.0294 17.9687L17.9687 19.0294L11.9991 13.0597L6.02941 19.0294L4.96875 17.9687L10.9384 11.9991Z", fillRule: "evenodd" })),
        size === 'small' && (react_1.default.createElement("path", { d: "M13.5303 3.53027L9.06055 8L13.5303 12.4697L12.4697 13.5303L8 9.06055L3.53027 13.5303L2.46973 12.4697L6.93945 8L2.46973 3.53027L3.53027 2.46973L8 6.93945L12.4697 2.46973L13.5303 3.53027Z" }))));
});
exports.CloseOutlined.displayName = 'CloseOutlined';
//# sourceMappingURL=CloseOutlined.js.map